import { Controller } from "@hotwired/stimulus"
const A4_PX = 1123
// Scales the live preview down to a single page, and mirrors that choice onto
// the PDF export link as ?fit=1 (print.html.erb applies the same scale when the
// param is present) so the download matches what the preview shows.
//
// The toggle button and the export link are queried document-wide rather than
// declared as targets because both live in _format_toolbar.html.erb, a sibling
// of this controller's element. They used to be queried by the old floating
// toolbar's target names, which stopped existing when that partial was
// retired — leaving the button sync and the ?fit=1 rewrite as silent no-ops.
const TOGGLE_SELECTOR = "[data-resume-fit-toggle]"
const EXPORT_SELECTOR = "[data-resume-fit-export]"
export default class extends Controller {
  connect() {
    this.toggle = this.toggle.bind(this); this.apply = this.apply.bind(this)
    window.addEventListener("resume:toggle-fit", this.toggle)
    document.addEventListener("turbo:frame-load", this.apply)
    try { this.on = localStorage.getItem("rb-page-fit") === "1" } catch (_e) { this.on = false }
    // The preference is sticky, so a page that loads with fit already on must
    // show the toggle as pressed — otherwise the first click reads as turning
    // fit *on* while it actually turns it off.
    this.syncToggle(); this.apply(); this.syncExport()
  }
  disconnect() { window.removeEventListener("resume:toggle-fit", this.toggle); document.removeEventListener("turbo:frame-load", this.apply) }
  toggle() {
    this.on = !this.on
    try { localStorage.setItem("rb-page-fit", this.on ? "1" : "0") } catch (_e) {}
    this.syncToggle(); this.apply(); this.syncExport()
  }
  syncToggle() {
    document.querySelectorAll(TOGGLE_SELECTOR).forEach((b) => b.setAttribute("aria-pressed", this.on ? "true" : "false"))
  }
  apply() {
    const doc = this.element.querySelector("#resume_preview .rb-doc"); if (!doc) return
    if (!this.on) { doc.style.transform = ""; doc.style.transformOrigin = ""; return }
    const h = doc.scrollHeight; let k = h > 0 ? A4_PX / h : 1
    k = Math.max(0.5, Math.min(1, k)); doc.style.transformOrigin = "top center"; doc.style.transform = `scale(${k})`
  }
  syncExport() {
    const on = this.on
    document.querySelectorAll(EXPORT_SELECTOR).forEach((a) => {
      try { const u = new URL(a.href); if (on) u.searchParams.set("fit", "1"); else u.searchParams.delete("fit"); a.setAttribute("href", u.toString()) } catch (_e) {}
    })
  }
}
